import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {DateFormats} from 'src/app/domain/date-params';
import {SettlementCard} from '../../../../domain/settlement-card';
import {IonicModule} from '@ionic/angular';
import {DateFormatPipe} from '../../../../pipes/date-format/date-format.pipe';

@Component({
  selector: 'app-bubble-chart-card',
  imports: [IonicModule, DateFormatPipe],
  templateUrl: './bubble-chart-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./bubble-chart-card.component.scss']
})
export class BubbleChartCardComponent {
  public readonly DateFormats = DateFormats;

  @Input() settlementCard: SettlementCard;
  @Input() selected: boolean;
  @Output() readonly selectSymbol = new EventEmitter<string>();

  public onSymbolSelect(): void {
    this.selectSymbol.emit(this.settlementCard.currency);
  }
}
